import React, { useState } from 'react';
import { IoChevronBack, IoChevronForward } from 'react-icons/io5';

const MiniCalendar = ({ selectedDate, onSelectDate }) => {
    const [currentMonth, setCurrentMonth] = useState(new Date());

    const getDaysInMonth = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        const startingDayOfWeek = firstDay.getDay();

        const days = [];
        // Add empty slots for days before month starts
        for (let i = 0; i < startingDayOfWeek; i++) {
            days.push(null);
        }
        // Add all days in month
        for (let i = 1; i <= daysInMonth; i++) {
            days.push(new Date(year, month, i));
        }
        return days;
    };

    const days = getDaysInMonth(currentMonth);
    const weekDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isPastDate = (date) => {
        if (!date) return false;
        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);
        return checkDate < today;
    };

    const isToday = (date) => {
        if (!date) return false;
        return isSameDay(date, today);
    };

    const isSelected = (date) => {
        if (!date || !selectedDate) return false;
        return isSameDay(date, selectedDate);
    };

    const handlePrevMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1));
    };

    const handleNextMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1));
    };

    const monthYear = currentMonth.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

    return (
        <div className="space-y-3">
            <div className="text-xs font-medium text-gray-500 mb-2">Select Date</div>

            {/* Month Navigation */}
            <div className="flex items-center justify-between mb-2">
                <button
                    onClick={handlePrevMonth}
                    className="p-1 hover:bg-gray-100 rounded"
                >
                    <IoChevronBack className="w-4 h-4" />
                </button>
                <div className="text-sm font-medium">{monthYear}</div>
                <button
                    onClick={handleNextMonth}
                    className="p-1 hover:bg-gray-100 rounded"
                >
                    <IoChevronForward className="w-4 h-4" />
                </button>
            </div>

            {/* Week Days */}
            <div className="grid grid-cols-7 gap-1 mb-1">
                {weekDays.map((day) => (
                    <div key={day} className="text-center text-xs text-gray-500 font-medium">
                        {day}
                    </div>
                ))}
            </div>

            {/* Calendar Grid */}
            <div className="grid grid-cols-7 gap-1">
                {days.map((date, index) => {
                    if (!date) {
                        return <div key={`empty-${index}`} className="w-9 h-9" />;
                    }

                    const past = isPastDate(date);
                    const todayDate = isToday(date);
                    const selected = isSelected(date);

                    return (
                        <button
                            key={date.toISOString()}
                            onClick={() => !past && onSelectDate(date)}
                            disabled={past}
                            className={`w-9 h-9 rounded-full text-sm font-medium transition-colors ${selected
                                    ? 'bg-indigo-600 text-white'
                                    : todayDate
                                        ? 'bg-indigo-50 text-indigo-900'
                                        : past
                                            ? 'text-gray-300 cursor-not-allowed'
                                            : 'hover:bg-gray-100 text-gray-700'
                                }`}
                        >
                            {date.getDate()}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

const isSameDay = (date1, date2) => {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
};

export default MiniCalendar;
